@if (showIcon() && iconClass()) {
    <i class="status-badge__icon" [class]="iconClass()" aria-hidden="true" [style.font-size.px]="iconSize()"></i>
}
@if (showText() && (label() || resolvedTranslationKey())) {
    <span class="status-badge__label">
        @if (label()) {
            {{ label() }}
        } @else {
            {{ resolvedTranslationKey()! | transloco }}
        }
    </span>
}
@if (hasTooltip()) {
    <div
        #tooltipEl
        class="status-badge__tooltip"
        [class.status-badge__tooltip--visible]="isTooltipVisible()"
        [class.status-badge__tooltip--wide]="entityDetailBlockRows()"
        [style.top.px]="tooltipTop()"
        [style.left.px]="tooltipLeft()"
        role="tooltip"
    >
        @if (isLoadingEntityDetailTooltip()) {
            <span class="status-badge__tooltip-loading">
                <dx-load-indicator [visible]="true" [height]="14" [width]="14"></dx-load-indicator>
                {{ 'loadingEntityDetails' | transloco }}
            </span>
        } @else if (entityDetailBlockRows()) {
            <table class="status-badge__tooltip-block-table">
                <thead>
                    <tr>
                        <th>{{ 'label_blockReason' | transloco }}</th>
                        <th>{{ 'label_description' | transloco }}</th>
                    </tr>
                </thead>
                <tbody>
                    @for (row of entityDetailBlockRows()!; track $index) {
                        <tr>
                            <td>{{ row.reasonLabel }}</td>
                            <td>{{ row.description ?? '—' }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        } @else if (entityDetailTooltipText()) {
            <span class="status-badge__tooltip-entity-detail">{{ entityDetailTooltipText() }}</span>
        } @else if (tooltip()) {
            {{ tooltip() }}
        } @else if (tooltipTranslationKey()) {
            {{ tooltipTranslationKey()! | transloco }}
        }
        @if (clickHintTranslationKey(); as hintKey) {
            <div class="status-badge__tooltip-hint">{{ hintKey | transloco }}</div>
        }
    </div>
}
